import { render, staticRenderFns } from "./EiNumList.vue?vue&type=template&id=55db2992&scoped=true&"
import script from "./EiNumList.vue?vue&type=script&lang=js&"
export * from "./EiNumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db2992",
  null
  
)

export default component.exports